import { useEventsQuery } from "../../../../generated/graphql"
import transformEvents from "./transformEvents"

export default function useGetCircus2025Sessions() {
    const ids = [
        "1834",
        "1835",
        "1836",
        "1837",
        "1838",
        "1839",
        "1840",
        "1841",
        "1842",
        "1843",
        "1844",
        "1845",
        "1846",
        "1847",
        "1861"
    ]
    const { data } = useEventsQuery({ variables: { paging: { limit: 999 }, filter: { id: { in: ids } } } })
    return transformEvents(data)
}

